<template>
  <v-form>
    <v-card>
      <v-container class="pa-6" v-if="!loading">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="6">
            <v-select v-model="region" :items="regionList" :item-text="'name'" :item-value="'uuid'" dense outlined
              label="Region"></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field outlined dense v-model="form.name" required label="Zone Name"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select v-model="form.status" :items="statusList" dense outlined label="Status"></v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6">
          </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="update()">Update</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
    <Snackbars :text="'Validation error please scroll up'" :snackbar="snackbarError" :color="'red'"
      @classSnackbar="closeSnackbar" />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { CommonService } from "@/services/common-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";

export default {
  name: "CreateMember",
  components: { Alert, Snackbars },

  data: () => ({
    role: localStorage.getItem("role") || null,
    form: {
      name: null,
      lions_club_region: null,
      status: null
    },

    region: null,

    snackbar: false,
    snackbarError: false,
    successMsg: "Zone has been updated successfully",
    errors: null,
    loading: false,
    regionList: [],
    zoneList: [],
    statusList: ["ACTIVE", "INACTIVE"],
  }),

  watch: {
    region(val) {
      if (val !== null) {
        this.form.lions_club_region = val
      }

    }
  },

  mounted() {
    this.onDismissed();
    this.getRegionList();
    this.getZoneInfo();
  },

  methods: {
    update() {
      this.loading = true;
      this.errors = null;
      CommonService.zoneUpdate(this.$route.params.id, this.form)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.snackbar = true;
            this.snackbarError = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          window.scrollTo(0, 0);

        });
    },

    getRegionList() {
      this.loading = true;
      CommonService.getAllRegions()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.regionList = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.regionList = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },



    getZoneInfo() {
      this.loading = true;
      CommonService.getZoneInfo(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.form.name = response.data.data?.name;
            this.form.status = response.data.data?.status;
            this.region = response.data.data?.region.uuid;
            this.form.lions_club_region = response.data.data?.region.uuid;
          }
        })
        .catch((error) => {
          this.form = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.loading = false;
        });
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
      this.region = null
    },
  },
};
</script>
